export class Constants {

    // static readonly WHITEBOARD_SHARED_ID = 'whiteboard-shared';
    static readonly MAX_ONREJECT_RETRY = 5;

    static readonly PARAM_BROWSER_LANG = 'browserLang';
    static readonly PARAM_LANG = 'lang';
    static readonly PARAM_ALIAS = 'alias';

    static readonly DEFAULT_LANGUAGE = 'it';

    static readonly AUTORESET_TIMEOUT_MS = 30000; // 30 secondi
    // static readonly LANGUAGES_LIST = 
    
    // [
    //   {'value': 'en', 'label': 'English'},
    //   {'value': 'it', 'label': 'Italiano'},
    //   {'value': 'es', 'label': 'Español'},
    //   {'value': 'fr', 'label': 'Français'},
    //   {'value': 'de', 'label': 'Deutsch'},
    //   {'value': 'et', 'label': 'Eesti'},
    //   {'value': 'gr', 'label': 'Ελληνικά'},
    //   {'value': 'lt', 'label': 'Lietuvių kalba'},
    //   {'value': 'mk', 'label': 'Македонски јазик'},
    //   {'value': 'sq', 'label': 'Shqip'}
    // ];
    // static readonly ALLOWED_LANGUAGES = Constants.LANGUAGES_LIST.map( z => z.value );
    static readonly ALLOWED_LANGUAGES = [
      'en', 
      'it', 
      'es', 
      'fr', 
      'de', 
      'et',
      'el', 
      'lt',
      'mk',
      'sq',
      'pl',
      'am'
    ];

    static readonly DEFAULT_LATITUDE = 41.063631;
    static readonly DEFAULT_LONGITUDE = 11.593449;
    static readonly DEFAULT_ALTIITUDE = 0;
  }